import { render, staticRenderFns } from "./approvalList.vue?vue&type=template&id=0539a64c&scoped=true&lang=pug"
import script from "./approvalList.vue?vue&type=script&lang=js"
export * from "./approvalList.vue?vue&type=script&lang=js"
import style0 from "./approvalList.vue?vue&type=style&index=0&id=0539a64c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539a64c",
  null
  
)

export default component.exports